export const LowercaseFirstLetter = (text: string) => {
    return text.charAt(0).toLowerCase() + text.slice(1);
};
